module.exports = __webpack_public_path__ + "static/img/er_wh.ce96eee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/er_wh.jpg
// module id = iGCQ
// module chunks = 1